import React, { Component } from 'react';
import Presenter from './presenter';
import Model from './model';
import View from './view';

export default class LoginLink extends Component {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(new Model(this, {}));
  }

  render() {
    const { notificationType, config } = this.props;
    const { allow_phone: allowPhone, allow_email: allowEmail } = config?.token ?? {};
    return (
      <View
        {...this.state}
        presenter={this.presenter}
        notificationType={notificationType}
        allowPhone={allowPhone}
        allowEmail={allowEmail}
      />
    );
  }
}
